import { DOWNLOAD_APP_EVENT_LABELS } from 'constants/analytics';

import StoreButton from '../StoreButton';

import * as S from './styled';

const DownloadWithMobileLinks = ({
    isIos,
    isAndroid,
    handleLinkDownloadApp,
}: {
    isIos: boolean;
    isAndroid: boolean;
    handleLinkDownloadApp: (eventLabel: string, isDeeplinkBtn?: boolean) => void;
}) => {
    return (
        <S.FlexWrapper>
            {isIos && (
                <div
                    onClick={() => handleLinkDownloadApp(DOWNLOAD_APP_EVENT_LABELS.ios_top)}
                    data-locator="appleStoreLink"
                >
                    <StoreButton isMobile type="apple" />
                </div>
            )}
            {isAndroid && (
                <div
                    onClick={() => handleLinkDownloadApp(DOWNLOAD_APP_EVENT_LABELS.android_top)}
                    data-locator="googleStoreLink"
                >
                    <StoreButton isMobile type="google" />
                </div>
            )}
        </S.FlexWrapper>
    );
};

export default DownloadWithMobileLinks;
